import * as Yup from 'yup';

export const schema = Yup.object().shape({
  nome: Yup.string().required('Nome do lembrete é obrigatório'),
  data: Yup.string().required('Seleciona uma data'),
  dataHoraInicio: Yup.string().required('Seleciona uma hora para o início do lembrete'),
  dataHoraTermino: Yup.string().required('Seleciona uma hora para o término do lembrete'),
});
